export async function initGamesSearchModal() {
  let searchList = document.querySelectorAll('.js-open-search');
  for (let i = 0, len = searchList.length; i < len; i++) {
    searchList[i].addEventListener('click', createGamesSearchModal);
  }
}

export async function createGamesSearchModal() {
  let modalSearchEl = document.querySelector('.modal-search');
  if (!modalSearchEl) {
    const moduleGames = await import('../../games.js');
    const { default: ModalSearch } = await import('../../../classes/modalSearch');
    let modalSearch = new ModalSearch({
      mainClass: 'modal-search',
      additionalClasses: 'search',
      containerClass: 'modals',
      containerSelector: '.modals'
    });
    moduleGames.initGamesSearch();
    modalSearch.setVisible(true);
    document.body.classList.add('modal-search-open');
  } else {
    modalSearchEl.classList.add('active');
    document.body.classList.add('modal-search-open');
  }
  setTimeout(() => {
    document.querySelector('.modal-search .search-input').focus();
    document.querySelector('.modal-search .search-input').select();
  }, 100);
  return document.querySelector('.modal-search');
}
